import React from 'react';

import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ApiKeysContainer from '../../ApiKeysContainer';

const StyledHeaderContainer = styled.div`
    display: flex;
    margin-bottom: 10px;
`;

const StyledTitle = styled(Typography)`
    font-size: 24px;
    margin-right: auto;
`;

const StyledButton = styled(Button)`
    margin-left: 15px;
`;

const KeysListHeader: React.FC = () => {
    const { t } = useTranslation('admin_settings');
    const { setSelectedKey, setFormActionType } = useContainer(ApiKeysContainer);
    const history = useHistory();
    const { path } = useRouteMatch();

    const handleCreateNewKey = () => {
        setSelectedKey(null);
        setFormActionType('CREATE');
        history.push(`${path}/create`);
    };

    return (
        <StyledHeaderContainer>
            <StyledTitle variant="h1">{t('api-keys.api-keys')}</StyledTitle>
            {/* {TODO: the documentation doesn't exist yet, no place to link. just added a default for now} */}
            <Button variant="outlined" href="https://developer.class.com/" target="_blank" rel="noreferrer">
                {t('api-keys.buttons.documentation')}
            </Button>
            <StyledButton variant="contained" onClick={handleCreateNewKey}>
                {t('api-keys.buttons.add-new-key')}
            </StyledButton>
        </StyledHeaderContainer>
    );
};

export default KeysListHeader;
